/**
 * Input Edge Detection + Frame Conversion — shared utilities for phase logic.
 *
 * justPressed() — edge-triggered key detection (bonkjs only provides held state).
 * msToFrames() — convert milliseconds to fixed-update frame count (60fps).
 */

import type { InputProvider } from '../input';

/** Convert milliseconds to fixed-update frame count (60fps). */
export const msToFrames = (ms: number) => Math.round(ms * 60 / 1000);

// ─── Edge-triggered key detection (bonkjs only has Input.getKey) ─────────────
const prevKeys = new Map<string, boolean>();
let lastInputProvider: InputProvider | null = null;

export function justPressed(key: string, input: InputProvider): boolean {
  // Clear tracking when input provider changes (turn switch) to prevent phantom presses
  if (input !== lastInputProvider) {
    prevKeys.clear();
    lastInputProvider = input;
  }
  const down = input.getKey(key);
  const wasDown = prevKeys.get(key) ?? false;
  prevKeys.set(key, down);
  return down && !wasDown;
}
